import { render, staticRenderFns } from "./MultiselectDiscounts.vue?vue&type=template&id=4a8f5f44&"
import script from "./MultiselectDiscounts.vue?vue&type=script&lang=js&"
export * from "./MultiselectDiscounts.vue?vue&type=script&lang=js&"
import style0 from "./MultiselectDiscounts.vue?vue&type=style&index=0&lang=scss&scope=app%2Fassets%2Fstylesheets%2Fcomponents%2Flodging-filter&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports